import { Pipe, PipeTransform } from '@angular/core';
import { DateUtility } from '@jms/model';

@Pipe({
    name: 'toDate',
    pure: false,
    standalone: true
})
export class ToDatePipe implements PipeTransform {
    transform(value) {

        if (value) {
            const date = DateUtility.getDateTime(value);
            return date?.toJSDate();
        }

        return null;
    }
}
